import { FC, useState } from "react";
import {
    LicenseType,
    NotActivatedLicenseKey,
    NotActivatedLicenseKeyRow,
} from "../model";
import { ColumnDef, VisibilityState } from "@tanstack/react-table";
import CopyToClipboard from "../../../../../assets/components/CopyToClipboard/CopyToClipboard";
import moment from "moment";
import Table from "../../../../../assets/components/Table/Table";
import { Products } from "../../../../../models/models";
import TableColumnVisibilityMenu from "../../../../../assets/components/Table/TableColumnVisibilityMenu";

const getLicenseTypeKey = (value: number): keyof typeof LicenseType => {
    return LicenseType[value] as keyof typeof LicenseType;
};

interface LicenseKeysNotActivatedTableProps {
    licenseKeys: NotActivatedLicenseKey[];
    products: Products;
}

const LicenseKeysNotActivatedTable: FC<LicenseKeysNotActivatedTableProps> = ({
    licenseKeys,
    products,
}) => {
    const defaultColumnVisibility: VisibilityState = {};

    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(
        defaultColumnVisibility,
    );

    const handleResetColumnVisibility = () => {
        setColumnVisibility(defaultColumnVisibility);
    };

    const columns: ColumnDef<NotActivatedLicenseKeyRow>[] = [
        {
            id: "orderId",
            header: "Order ID",
            accessorFn: ({ orderId }) => orderId,
            size: 120,
        },
        {
            id: "subscriptionType",
            header: "Subscription Type",
            accessorFn: ({ licenseType, productTitle, nextRebillDate }) =>
                `${getLicenseTypeKey(licenseType)} ${productTitle} (${moment
                    .unix(Number(nextRebillDate))
                    .format("LLL")})`,
            size: 300,
        },
        {
            id: "orderDate",
            header: "Order Date",
            accessorFn: ({ lastRebillDate }) =>
                moment.unix(Number(lastRebillDate)).format("LLL"),
            size: 180,
        },
        {
            id: "licenseKey",
            header: "License Key",
            accessorFn: ({ key }) => key,
            size: 200,
            cell: ({ row }) => <CopyToClipboard text={row.original.key} />,
        },
    ];

    return (
        <Table<NotActivatedLicenseKeyRow>
            borderRadius="small"
            data={licenseKeys}
            columns={columns}
            getRowCanExpand={() => false}
            enableColumnVisibility={true}
            columnVisibility={columnVisibility}
            onColumnVisibilityChange={setColumnVisibility}
            renderTopToolbar={(table) => (
                <TableColumnVisibilityMenu
                    table={table}
                    onReset={handleResetColumnVisibility}
                />
            )}
        />
    );
};

export default LicenseKeysNotActivatedTable;
